import React from "react";
import {Link} from "gatsby-plugin-react-i18next";
import {LogoMarquee} from "./logo-strip";

const ProofBar = ({metrics, logos, label}) => (
    <section className="w-full max-w-screen-2xl mx-auto px-5">
        <div className="w-full bg-[var(--cl-surface)] border-t border-b border-[var(--cl-rule)]">
            {metrics && metrics.length ? (
                <div className="grid grid-cols-1 sm:grid-cols-3 divide-y sm:divide-y-0 sm:divide-x divide-[var(--cl-rule)]">
                    {metrics.map((m) => (
                        <Link
                            key={m.value + m.client}
                            to={m.to}
                            className="group px-6 py-6 sm:py-7 flex flex-col gap-2 hover:bg-[var(--cl-surface-2)] transition-colors"
                        >
                            <span className="cl-num text-3xl sm:text-[2.1rem] font-bold leading-none tracking-[-0.03em] text-[var(--cl-accent)]">
                                {m.value}
                            </span>
                            <span className="text-[13px] leading-snug text-[var(--cl-ink-2)]">{m.label}</span>
                            <span className="cl-eyebrow group-hover:text-[var(--cl-ink)] transition-colors">{m.client}</span>
                        </Link>
                    ))}
                </div>
            ) : null}
            <div className={`${metrics && metrics.length ? "border-t border-[var(--cl-rule)] " : ""}pt-5 pb-5`}>
                {label ? <p className="cl-eyebrow text-center mb-3 px-4">{label}</p> : null}
                <LogoMarquee logos={logos}/>
            </div>
        </div>
    </section>
);

export default ProofBar;
